var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6306 18C20.5172 17.4817 21.2175 16.6615 21.6212 15.6689C22.0248 14.6763 22.1087 13.5678 21.8596 12.5183C21.6106 11.4689 21.0427 10.5383 20.2457 9.87342C19.4486 9.20854 18.4678 8.84722 17.458 8.84651H16.3127C16.0375 7.70523 15.5247 6.6457 14.8128 5.74756C14.1008 4.84943 13.2083 4.13606 12.2023 3.66109C11.1962 3.18611 10.1029 2.9619 9.00438 3.0053C7.90591 3.04871 6.8309 3.35859 5.86018 3.91167C4.88946 4.46475 4.04829 5.24662 3.3999 6.1985C2.75152 7.15039 2.31279 8.24752 2.11671 9.40741C1.92063 10.5673 1.97229 11.7598 2.26782 12.8952C2.56334 14.0306 3.09504 15.0793 3.82294 15.9627",
    stroke: "#3AB7B0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6378 13V21.1846",
    stroke: "#3AB7B0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2753 16.6376L11.6377 13L8.00008 16.6376",
    stroke: "#3AB7B0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.a5ef82cd430e8e55267788a8324d2a01.svg";
export { ForwardRef as ReactComponent };